import Button from '../Reusable/Button'
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useForm } from 'react-hook-form';
import { orderRemarksValidationForm } from '../../utils/validationSchema';
import APIS from '../../constant/EndPoint';
import useGetHook from '../../customHooks/useGetHook';
import usePostHook from '../../customHooks/usePostHook';
import moment from 'moment';
import { queryClient } from '../../root.component';

const Remark = (props: any) => {
  const { data: remarks } = useGetHook({
    queryKey: [`remakrs-${props?.selectedID}`],
    url: APIS.REMARK,
    params: {
      limit: 200,
      offset: 0,
      order: props?.selectedOrder
    },
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: [`remakrs-${props?.selectedID}`],
    navigateURL: "",
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    reset
  } = useForm<any>({
    resolver: yupResolver(orderRemarksValidationForm),
  });

  const handleCreateReview = async (data: any) => {
    const url = `${APIS.REMARK}`;
    let formData = {
      ...data,
      order: props?.selectedOrder
    };
    try {
      await mutateAsync({ url, formData, setError });
      reset()
      queryClient.refetchQueries()
    } catch (err) {
      console.log(err);
    }
  }

  // copied code from https://flowbite.com/blocks/publisher/comments/

  return (
    <>
      <section className="bg-white dark:bg-gray-900 mt-4">
        <div className="max-w-2xl mx-auto px-4">
          <form className="mb-6">
            <div className="py-2 px-4 mb-4 bg-white rounded-lg rounded-t-lg border border-gray-200 dark:bg-gray-800 dark:border-gray-700">
              <label htmlFor="comment" className="sr-only">Your comment</label>
              <textarea id="comment" rows={6}
                {...register("remark")}
                className="px-0 w-full text-sm text-gray-900 border-0 focus:ring-0 focus:outline-none dark:text-white dark:placeholder-gray-400 dark:bg-gray-800"
                placeholder="Write a comment..." required></textarea>
            </div>
            <div className="flex justify-end w-full">
              <div className="w-[100px] mr-4">
                <Button
                  label={"Create"}
                  isLoading={isPostLoading}
                  onClick={handleSubmit((data: any) =>
                    handleCreateReview(data)
                  )}
                />
              </div>
            </div>
          </form>
          {remarks?.results?.map((item: any, index: number) => (
            <article className="p-6 text-base bg-white border-t border-gray-200 dark:border-gray-700 dark:bg-gray-900" key={index}>
              <footer className="flex justify-between items-center mb-2">
                <div className="flex items-center">
                  <div className='flex justify-start gap-x-2'>
                    <div className='w-12 h-12 rounded-full bg-gray-300 items-center justify-center flex'>
                      <p className='text-4xl text-primary'>{item?.user.is_staff ? "Staff".slice(0, 1) : item?.user?.name?.slice(0, 1)}</p>
                    </div>
                    <p className="inline-flex items-center mr-3 text-sm text-gray-900 dark:text-white">{item?.user.is_staff ? "Staff" : item?.user.name}</p>
                  </div>

                  <p className="text-sm text-gray-600 dark:text-gray-400">{moment(item?.created).format('YYYY-MM-DD hh:mm:ss A')}</p>
                </div>
              </footer>
              <p className="text-gray-500 dark:text-gray-400 ml-14">{item?.remark}</p>
            </article>
          ))}

        </div>
      </section>
    </>
  )
}

export default Remark
